<template>
  <v-row align="center">
    <v-col cols="12">
      <v-autocomplete
        outlined
        multiple
        hide-details
        dense
        chips
        item-value="id"
        item-text="title"
        no-data-text="Список пуст"
        placeholder="Начните вводить для поиска..."
        :items="entities"
        :value="value"
        :disabled="$apollo.queries.entities.loading"
        :loading="$apollo.queries.entities.loading"
        :search-input.sync="search"
        @change="updateValueHandler"
      >
        <template #selection="data">
          <draggable
            :id="data.index"
            :list="value"
            v-bind="dragOptionsChips"
            :move="move"
            @change="$emit('drag-change', { value: $event, dragged })"
          >
            <v-chip
              draggable
              :value="value[data.index]"
              :key="data.item.id"
              @mousedown.stop
              @click.stop
            >
              {{data.item.title}}
            </v-chip>
          </draggable>
        </template>
      </v-autocomplete>
    </v-col>
  </v-row>
</template>

<script>
import availableEntities from '@/components/dynamic-list-items/widgets/feeds/inputs/availableEntities.js'
import draggable from 'vuedraggable'
export default {
  name: 'RelationChosenWidgetInput',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    entity: {
      type: String,
      default: null
    }
  },
  components: {
    draggable
  },
  data () {
    return {
      entities: [],
      search: null,
      dragged: {
        from: -1,
        to: -1,
        newIndex: -1
      },
      selectedSync: [2]
    }
  },
  computed: {
    dragOptionsChips () {
      return {
        animation: 200,
        group: 'group',
        disabled: false,
        ghostClass: 'ghost',
        sort: true
      }
    }
  },
  methods: {
    updateValueHandler (value) {
      this.search = null
      this.$emit('input', value)
    },
    move (value) {
      this.dragged = {
        from: parseInt(value.from.id),
        to: parseInt(value.to.id),
        newIndex: value.draggedContext.futureIndex
      }
    }
  },
  apollo: {
    entities: {
      fetchPolicy: 'network-only',
      debounce: 1000,
      query () {
        return this.entity ? availableEntities[this.entity] : availableEntities.default
      },
      skip () {
        return this.search ? false : !this.value
      },
      variables () {
        // const where = {}
        // if (this.search) where.title_contains = this.search
        const where = {}
        if (this.search) where.title_contains = this.search
        else where.id_in = this.value
        return { where }
      },
      update (data) {
        this.entities = data[this.entity]
      },
      result ({ data }) {
        this.entities = data[this.entity].list
      }
    }
  }
}
</script>
